// import SideNavbaBarDashboard from "../SideNavaBarDashboard/SideNavbaBarDashboard";
// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { format } from 'date-fns';


// const Orders = () => { 
//     const [ordersdata, setOrdersdata] = useState([]);
//     const [error, setError] = useState(null);

//     useEffect(() => {
//         // Fetch order data based on phone number from localStorage
//         axios.get(`/api/fetch-order/${localStorage.getItem("phoneNumber")}`)
//             .then((response) => {
//                 setOrdersdata(response.data);
//             })
//             .catch((error) => {
//                 setError('Error fetching orders');
//                 console.error('Error fetching orders:', error);
//             });
//     }, []);
//     const formatOrderDate = (date) => {
//         return format(new Date(date), 'dd/MM/yyyy'); // Format to MM/DD/YYYY
//     };
//     const handleCancelOrder = async (orderId) => {
//         try {
//             // Make a POST request to your backend API to send the cancellation email
//             const response = await fetch('/api/cancel-order', {
//                 method: 'POST',
//                 headers: {
//                     'Content-Type': 'application/json',
//                 },
//                 body: JSON.stringify({ orderId: orderId }), // Pass the order ID
//             });
    
//             const data = await response.json();
    
//             if (response.ok) {
//                 alert('Cancellation request has been sent to the admin!');
//             } else {
//                 alert('Error sending cancellation request');
//             }
//         } catch (error) {
//             console.error('Error:', error);
//             alert('An error occurred while sending the request');
//         }
//     };
    
//     return (
//         <>
//             <div className="tf-page-title">
//                 <div className="container-full">
//                     <div className="heading text-center">My Orders</div>
//                 </div>
//             </div>

//             <section className="flat-spacing-11">
//                 <div className="container">
//                     <div className="row">
//                         <SideNavbaBarDashboard />
//                         <div className="col-lg-9">
//                             <div className="my-account-content account-order">
//                                 <div className="wrap-account-order">
//                                     <table>
//                                         <thead>
//                                             <tr>
//                                                 <th className="fw-6">Order</th>
//                                                 <th className="fw-6">Date</th>
//                                                 <th className="fw-6">Order Status</th>
//                                                 <th className="fw-6">Delivery Status</th>
//                                                 <th className="fw-6">Total</th>
//                                                 <th className="fw-6">Cancel</th>
//                                             </tr>
//                                         </thead>
//                                         <tbody>
//                                             {error && <tr><td colSpan="4">{error}</td></tr>}
//                                             {ordersdata.length === 0 ? (
//                                                 <tr>
//                                                     <td colSpan="4">No orders found.</td>
//                                                 </tr>
//                                             ) : (
//                                                 ordersdata.map((order) => (
//                                                     <tr className="tf-order-item" key={order.orderId}>
//                                                         <td>{order.orderId}</td>
//                                                         <td>{formatOrderDate(order.orderDate)}</td> {/* Format date here */}
//                                                         <td>{order.orderStatus}</td>
//                                                         <td>{order.deliveryStatus}</td>
//                                                         <td>{order.paymentDetails?.totalAmount}</td>
//                                                         <td>
//                                                             {order.deliveryStatus === 'pending' && (
//                                                                 <button
//                                                                     className="tf-btn btn-fill animate-hover-btn rounded-0 justify-content-center"
//                                                                     onClick={() => handleCancelOrder(order.orderId)} // Call the cancel function when button is clicked
//                                                                 >
//                                                                     Cancel
//                                                                 </button>
//                                                             )}
//                                                         </td>

//                                                     </tr>
//                                                 ))
                                                
//                                             )}
//                                         </tbody>
//                                     </table>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </section>

//             <div className="btn-sidebar-account">
//                 <button data-bs-toggle="offcanvas" data-bs-target="#mbAccount" aria-controls="offcanvas">
//                     <i className="icon icon-sidebar-2"></i>
//                 </button>
//             </div>

//             <div className="offcanvas offcanvas-start canvas-filter canvas-sidebar canvas-sidebar-account" id="mbAccount">
//                 <div className="canvas-wrapper">
//                     <header className="canvas-header">
//                         <span className="title">SIDEBAR ACCOUNT</span>
//                         <SideNavbaBarDashboard />
//                         <span className="icon-close icon-close-popup" data-bs-dismiss="offcanvas" aria-label="Close"></span>
//                     </header>
//                     <div className="canvas-body sidebar-mobile-append"> </div>
//                 </div>
//             </div>
//         </>
//     );
// };

// export default Orders;


import SideNavbaBarDashboard from "../SideNavaBarDashboard/SideNavbaBarDashboard";
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { BiCategoryAlt } from "react-icons/bi";
import { IoSearchOutline } from "react-icons/io5";
import { MdOutlineAccountCircle } from "react-icons/md";
import { FaShoppingCart } from "react-icons/fa";
import { IoHome } from "react-icons/io5";
import { Link } from "react-router-dom";
import { AiOutlineDoubleRight } from "react-icons/ai";
import { format } from 'date-fns';
import { CiMenuBurger } from "react-icons/ci";
const Orders = () => { 
    const [ordersdata, setOrdersdata] = useState([]);
    const [error, setError] = useState(null);

    useEffect(() => {
        // Fetch order data based on phone number from localStorage
        axios.get(`/api/fetch-order/${localStorage.getItem("phoneNumber")}`)
            .then((response) => {
                setOrdersdata(response.data);
            })
            .catch((error) => {
                setError('Error fetching orders');
                console.error('Error fetching orders:', error);
            });
    }, []);

    const formatOrderDate = (date) => {
        return format(new Date(date), 'dd/MM/yyyy');
    };

    // Check if order is within 3 hours
    const isWithinCancelWindow = (orderDate) => {
        const orderTime = new Date(orderDate).getTime();
        const currentTime = new Date().getTime();
        const threeHoursInMs = 3 * 60 * 60 * 1000;
        return currentTime - orderTime <= threeHoursInMs;
    };

    // Calculate time remaining for cancellation
    const getTimeRemaining = (orderDate) => {
        const orderTime = new Date(orderDate).getTime();
        const currentTime = new Date().getTime();
        const timeRemaining = (orderTime + (3 * 60 * 60 * 1000)) - currentTime;
        
        if (timeRemaining <= 0) return "";
        
        const hoursLeft = Math.floor(timeRemaining / (1000 * 60 * 60));
        const minutesLeft = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
        
        return `${hoursLeft}h ${minutesLeft}m left to cancel`;
    };

    const handleCancelOrder = async (orderId) => {
        try {
            const response = await fetch('/api/cancel-order', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ orderId: orderId }),
            });
    
            const data = await response.json();
    
            if (response.ok) {
                alert('Cancellation request has been sent to the admin!');
                // Refresh orders after cancellation
                const updatedOrders = await axios.get(`/api/fetch-order/${localStorage.getItem("phoneNumber")}`);
                setOrdersdata(updatedOrders.data);
            } else {
                alert('Error sending cancellation request');
            }
        } catch (error) {
            console.error('Error:', error);
            alert('An error occurred while sending the request');
        }
    };
    
    return (
        <>
<div class="tf-page-title">
                <div class="row">
                    <div class="col-12">
                        <div class="heading text-center ">
                            <h4 className='breadcrumbtitle'>My Orders</h4>
                            <div className=' breadcrumb'>
                                <Link to="/" style={{ color: "black" }} ><h6>Home</h6></Link><AiOutlineDoubleRight size={20} style={{ marginTop: "0.5vh" }} />
                                <h6>My Orders</h6></div>
                        </div>
                    </div>
                </div>

            </div>

            <section className="flat-spacing-11">
                <div className="container">
                    <div className="row">
                        <SideNavbaBarDashboard />
                        <div className="col-lg-9">
                            <div className="my-account-content account-order">
                                <div className="wrap-account-order">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th className="fw-6">Order</th>
                                                <th className="fw-6">Date</th>
                                                <th className="fw-6">Order Status</th>
                                                <th className="fw-6">Delivery Status</th>
                                                <th className="fw-6">Total</th>
                                                <th className="fw-6">Cancel</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {error && <tr><td colSpan="6">{error}</td></tr>}
                                            {ordersdata.length === 0 ? (
                                                <tr>
                                                    <td colSpan="6">No orders found.</td>
                                                </tr>
                                            ) : (
                                                ordersdata.map((order) => (
                                                    <tr className="tf-order-item" key={order.orderId}>
                                                        <td>{order.orderId}</td>
                                                        <td>{formatOrderDate(order.orderDate)}</td>
                                                        <td>{order.orderStatus}</td>
                                                        <td>{order.deliveryStatus}</td>
                                                        <td>{order.paymentDetails?.totalAmount}</td>
                                                        <td>
                                                            {order.deliveryStatus === 'pending' && (
                                                                <div>
                                                                    <button
                                                                        className="tf-btn btn-fill animate-hover-btn rounded-0 justify-content-center"
                                                                        onClick={() => handleCancelOrder(order.orderId)}
                                                                        disabled={!isWithinCancelWindow(order.orderDate)}
                                                                        style={{
                                                                            opacity: isWithinCancelWindow(order.orderDate) ? 1 : 0.5,
                                                                            cursor: isWithinCancelWindow(order.orderDate) ? 'pointer' : 'not-allowed'
                                                                        }}
                                                                    >
                                                                        Cancel
                                                                    </button>
                                                                    <div className="text-sm text-gray-600 mt-1">
                                                                        {getTimeRemaining(order.orderDate)}
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </td>
                                                    </tr>
                                                ))
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <div className="btn-sidebar-account">
                <button data-bs-toggle="offcanvas" data-bs-target="#mbAccount" aria-controls="offcanvas">
                    <CiMenuBurger />
                </button>
            </div>

            <div className="offcanvas offcanvas-start canvas-filter canvas-sidebar canvas-sidebar-account" id="mbAccount">
                <div className="canvas-wrapper">
                    <header className="canvas-header">
                        <span className="title">SIDEBAR ACCOUNT</span>
                        <SideNavbaBarDashboard />
                        <span className="icon-close icon-close-popup" data-bs-dismiss="offcanvas" aria-label="Close"></span>
                    </header>
                    <div className="canvas-body sidebar-mobile-append"> </div>
                </div>
            </div>
            <div class="tf-toolbar-bottom type-1150">
        <div class="toolbar-item">
            <a style={{color:"black"}} href="/">
                <div class="toolbar-icon">
                <IoHome />
                </div>
                <div class="toolbar-label">Home</div>
            </a>
        </div>
        <div class="toolbar-item">
            <a style={{color:"black"}} href="/products" >
                <div class="toolbar-icon">
                <BiCategoryAlt />
                </div>
                <div class="toolbar-label">Shop</div>
            </a>
        </div>
        <div class="toolbar-item">
            <a style={{color:"black"}} href="/SearchBar" >
                <div class="toolbar-icon">
                <IoSearchOutline />
                </div>
                <div class="toolbar-label">Search</div>
            </a>
        </div>
        <div class="toolbar-item">
            <a style={{color:"black"}} href="/cart">
                <div class="toolbar-icon">
                <FaShoppingCart />
                </div>
                <div class="toolbar-label">Cart</div>
            </a>
        </div>
    </div>
        </>
    );
};

export default Orders;